import React from "react";

import { useRentalInvoiceEditContext } from "./RentalInvoiceEditContainer";
import RentalInvoiceDepositRow from "./RentalInvoiceDepositRow";

const RentalInvoiceDepositsCard = () => {
  const {
    rentalInvoice,
    insertDeposit,
  } = useRentalInvoiceEditContext();

  const addDeposit = (e) => {
    e.preventDefault();
    insertDeposit({
      deposit_type: "percent",
      due_date_type: "relative",
      relative_due_date: 0,
      value: 0,
      paid: false,
    });
  };

  return (
    <div className="card">
      <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div className="setlist-text-lg setlist-font-semibold figma-text secondary">Deposits</div>
        {rentalInvoice.deposits.map((deposit) => {
          return <RentalInvoiceDepositRow key={deposit.id} deposit={deposit} />
        })}
        <a onClick={addDeposit} className="setlist-text-sm setlist-font-semibold figma-text link" style={{
          cursor: "pointer",
          display: "flex",
          gap: "4px",
          alignItems: "center",
          width: "fit-content",
        }}>
          <i className="fa-solid fa-plus" />
          Add Deposit
        </a>
      </div>
    </div>
  );
};

export default RentalInvoiceDepositsCard;
